import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { notificationsAPI } from "../../../services/api"

//i18n
import { withTranslation } from "react-i18next"

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false)
  const [notifications, setNotifications] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    fetchNotifications()
    // Poll every 5 seconds for a real-time feel since we don't use websockets yet
    const interval = setInterval(fetchNotifications, 5000)
    return () => clearInterval(interval)
  }, [])

  const fetchNotifications = async () => {
    try {
      const res = await notificationsAPI.getAll()
      const newNotifs = res.data;

      // If we have more unread notifications than before, show a toast
      const newUnreadCount = newNotifs.filter(n => !n.lu).length;
      if (newUnreadCount > unreadCount && unreadCount !== 0) {
        const latest = newNotifs.find(n => !n.lu);
        if (latest) {
          // You can adding a notification sound here if you have one
          // new Audio('/notification.mp3').play().catch(() => {});
        }
      }

      setNotifications(newNotifs)
      setUnreadCount(newUnreadCount)
    } catch (error) {
      console.error("Erreur notifications", error)
    }
  }

  const markAllAsRead = async () => {
    try {
      await notificationsAPI.markAllAsRead()
      fetchNotifications()
    } catch (error) {
      console.error("Erreur marquage lu", error)
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ti-bell"></i>
          {unreadCount > 0 && <span className="badge text-bg-danger rounded-pill">{unreadCount}</span>}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h5 className="m-0"> {props.t("Notifications")} ({unreadCount}) </h5>
              </Col>
              <Col className="col-auto">
                <button onClick={markAllAsRead} className="small text-primary border-0 bg-transparent">Tout marquer comme lu</button>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {notifications.map(n => (
              <div
                key={n.id}
                className={`text-reset notification-item ${!n.lu ? 'bg-light' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={async () => {
                  if (!n.lu) {
                    await notificationsAPI.markAsRead(n.id);
                    fetchNotifications();
                  }
                }}
              >
                <div className="d-flex p-3 border-bottom">
                  <div className="flex-shrink-0 me-3">
                    <div className="avatar-xs">
                      <span className={`avatar-title rounded-circle bg-${n.type === 'email' ? 'info' : 'success'}`}>
                        <i className={`mdi mdi-${n.type === 'email' ? 'email-outline' : 'whatsapp'}`}></i>
                      </span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">{n.titre}</h6>
                    <div className="text-muted">
                      <p className="mb-1">{n.message}</p>
                      <small><i className="mdi mdi-clock-outline"></i> {new Date(n.created_at).toLocaleString()}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {notifications.length === 0 && (
              <div className="p-4 text-center text-muted">Aucune notification</div>
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/notifications"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              Voir tout{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(NotificationDropdown)